import axios from "axios";

export default class Category {
  constructor() {
    this.base_url = process.env.REACT_APP_URL_CATALOG;
    this.name = "/categories";
    this.url = this.base_url + this.name;
  }

  grid = async (skip = 0, take = 100, active) => {
    return await axios.get(
      `${this.url}?skip=${skip}&take=${take}&active=${active}`
    );
  };

  select = async () => {
    return await axios.get(`${this.url}/select`);
  };

  getById = async (id) => {
    return await axios.get(`${this.url}/${id}`);
  };

  create = async (payload) => {
    await axios.post(`${this.url}`, payload);
  };

  update = async (id, payload) => {
    await axios.put(`${this.url}/${id}`, payload);
  };

  changeActive = async (id, payload) => {
    await axios.patch(`${this.url}/${id}`, payload);
  };
}
